module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Redeeming Transcendence in the Arts: Bearing Witness to the Triune God")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Contents#ack1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("This book comprises an expansion of the Stob Lectures delivered at Calvin College, Grand Rapids, Michigan, in November 2014. My warm thanks go to the faculty and students of both Calvin College and Calvin Theological Seminary for their welcome, hospitality, and probing questions. In particular, I would like to thank Calvin College president Michael Le Roy and Calvin Seminary president Julius Medenblik for their kindness during that visit; Suzanne McDonald for her endless energy, encouragement, and wisdom; and Jon Pott, formerly (and famously) of Eerdmans, who provided much-needed encouragement during the early stages of this book. Various kind friends and colleagues have read and commented on portions of the script: in particular, my gratitude goes to my right-hand man at Duke, Daniel Train, assistant director of Duke Initiatives in Theology and the Arts, for his immense wisdom and kindness on so many fronts; and to Richard Bauckham, Christina Carnes Ananias, Brian Curry, Stephanie Gehring Ladd, Brett Gray, Joelle Hathaway, Nate Jones, Murray Rae, David Taylor, and Andrew Torrance. I am grateful, as always, to my assistant Hillary Train, whose boundless calm and diligence have been crucial in getting this book to press; to James Ernest of Eerdmans, for his keen interest in the project throughout; to Alice Soulieux-Evans for completing numerous research, bibliographical, and copyediting "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("tasks; and above all to my wife, Rachel, for her ceaseless patience and support. The book is dedicated to Malcolm Guite, a poet-priest-theologian whose extraordinary insight and counsel I have come to value more than I could ever tell. I am thankful to Canterbury Press for allowing me to use two of his published poems, and to Malcolm himself for composing two new sonnets to accompany this text.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bdd91fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgments.vue
// module id = 72
// module chunks = 0